<template>
  <div>
    <panel title="Профайл">
      <div class="table-responsive">
        <table class="table">
          <tbody>
            <tr>
              <td>Аватар</td>
              <td>
                <img :src="`/images/avatar/` + user.avatar" class="imagePreviewWrapper">
              </td>
            </tr>
            <tr>
              <td>ID</td>
              <td>{{ user.id }}</td>
            </tr>
            <tr>
              <td>Имя</td>
              <td>{{ user.name }}</td>
            </tr>
            <tr>
              <td>Telegram</td>
              <td>{{ user.telegram_id }}</td>
            </tr>
            <tr>
              <td>Рейтинг</td>
              <td>{{ user.rating }}</td>
            </tr>
            <tr>
              <td>Рефер</td>
              <td>{{ user.ref_id }}</td>
            </tr>
            <tr>
              <td>Баланс</td>
              <td>{{ user.balance }}</td>
            </tr>
            <tr>
              <td>Заработано всего</td>
              <td>{{ user.balance_earn }}</td>
            </tr>
            <tr>
              <td>Заработано сегодня</td>
              <td>{{ user.balance_day }}</td>
            </tr>
            <tr>
              <td>Заработано на рефералах</td>
              <td>{{ user.balance_ref }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{ user.email }}</td>
            </tr>
            <!--<tr>
                            <td>Email подтвержден</td>
                            <td>{{ user.email_verified_at }}</td>
                        </tr>-->
            <tr>
              <td>Дата регистрации</td>
              <td>{{ user.created_at }}</td>
            </tr>
            <tr>
              <td>Дата активности</td>
              <td>{{ user.updated_at }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </panel>
  </div>
</template>

<script>
import HTTP from "../http";
import {show_error} from "../message";
import AppOptions from '../config/AppOptions.vue'


export default {
  data() {
    return {
      appOptions: AppOptions,
      loading: false,
      user: {},
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },

    fetchData() {
      this.$insProgress.start();
      this.loading = true;
      HTTP()
        .get("/user")
        .then((response) => {
          this.loading = false;
          this.user = response.data;
          if (this.user.ref_id <= 1) {
            this.user.ref_id = 'Нет'
          }
        })
        .catch((error) => {
          this.loading = false;
          show_error(
            this.$notify, error.response.data
          );
        }).finally(() => {
          this.$insProgress.finish();
        })
    },
  },
};
</script>

<style>
.w-120px {
  width: 120px !important;
}
</style>